import { Amplify } from 'aws-amplify';
 

// Configuración de AWS Amplify
// Nota: Debes reemplazar estos valores con tu configuración real de AWS
const amplifyConfig = {
  Auth: {
    Cognito: {
      // REQUERIDO - Solo para Cognito User Pool
      userPoolId: import.meta.env.VITE_USER_POOL_ID || 'us-east-1_xxxxxxxxx',
      
      // REQUERIDO - Solo para Cognito User Pool
      userPoolClientId: import.meta.env.VITE_USER_POOL_WEB_CLIENT_ID || 'xxxxxxxxxxxxxxxxxxxxxxxxxx',
      
      // REQUERIDO - Región de AWS
      region: import.meta.env.VITE_AWS_REGION || 'us-east-1',
      
      // OPCIONAL - Configuración adicional
      loginWith: {
        email: true,
        username: true
      }
    }
  }
};

// Inicializar Amplify
Amplify.configure(amplifyConfig);

export default amplifyConfig;

